import React from "react"
import styled from "styled-components"

import StateLogo from "./StateLogo"

const LogoContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;

  a {
    text-decoration: none;
    color: #3295ff;
    transition: 0.2s;

    &:hover {
      color: #0056b3;
    }
  }
`
const HeaderLogos = ({ fetcherType }) => {
  return (
    <LogoContainer>
      <StateLogo fetcherType={fetcherType} />
    </LogoContainer>
  )
}

export default HeaderLogos
